module.exports = __webpack_public_path__ + "img/图4@2x.e17d67de.png";